import config from './config'

export const SettingsAPI = {
    getAll: () => {
        return config.get('/api/merchant/settings/')
    },
    getUserProfile: () => {
        return config.get('/api/merchant/settings/profile/')
    },
}
